import React from "react";

import { BrasaoAraucaria, Logo } from "../../../shared/assets/logos";

import { Background } from "./styles";

interface PresentationProps {
    show: boolean;
}

export const Presentation: React.FC<PresentationProps> = ({ show }) => {
    return (
        <Background show={show}>
            <div className="grid grid-cols-1 gap-4 justify-items-center content-center md:grid-cols-2">
                <img
                    className="max-w-xl h-24 w-24"
                    src={BrasaoAraucaria}
                    alt="brasao"
                />
                <img className="max-w-sm max-h-24" src={Logo} alt="logo" />
            </div>
        </Background>
    );
};
